// Select Component

import React, { Component } from 'react'
import ReactSelect from 'react-select'
import _ from 'lodash'
import PropTypes from 'prop-types'
import classnames from 'classnames'

class Select extends Component {
  static get propTypes () {
    return {
      value: PropTypes.string,
      className: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string
        })
      ),
      onChange: PropTypes.func,
      isMulti: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      value: '',
      className: '',
      options: null,
      onChange: null,
      isMulti: false
    }
  }

  render () {
    const {
      value,
      options,
      onChange,
      isMulti,
      className,
      ...others
    } = this.props

    return (
      <ReactSelect
        className={classnames('cselect', className, {
          'cselect--is-multi': isMulti
        })}
        isMulti={isMulti}
        value={
          isMulti ? value : _.find(options, obj => obj.value === value) || null
        }
        options={options}
        classNamePrefix='cselect'
        {...others}
        onChange={onChange}
      />
    )
  }
}

export default Select
